import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableTingkatRisiko } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilTingkatRisiko = () => {
  const ref = useRef(null);
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [kodeTingkatRisiko, setKodeTingkatRisiko] = useState("");
  const [namaTingkatRisiko, setNamaTingkatRisiko] = useState("");
  const [tppuTingkatRisiko, setTppuTingkatRisiko] = useState("");
  const [tpptTingkatRisiko, setTpptTingkatRisiko] = useState("");
  const [ppspmTingkatRisiko, setPpspmTingkatRisiko] = useState("");

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [tingkatRisikos, setTingkatRisikos] = useState([]);
  const [tingkatRisikosPagination, setTingkatRisikosPagination] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getTingkatRisikosPagination();
    id && getTingkatRisikoById();
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [id, page, searchTerm]);

  const getTingkatRisikosPagination = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/tingkatRisikosPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setTingkatRisikosPagination(response.data.tingkatRisikos);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getTingkatRisikos = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/tingkatRisikos`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setTingkatRisikos(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getTingkatRisikoById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/tingkatRisikos/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setKodeTingkatRisiko(response.data.kodeTingkatRisiko);
      setNamaTingkatRisiko(response.data.namaTingkatRisiko);

      let pilihanTingkatRisikos = [
        {
          id: 0,
          nama: "-",
        },
        {
          id: 1,
          nama: "Tinggi",
        },
        {
          id: 2,
          nama: "Sedang",
        },
        {
          id: 3,
          nama: "Rendah",
        },
      ];

      let tempTppuTingkatRisiko = pilihanTingkatRisikos.find(
        (tingkatRisiko) => tingkatRisiko.id == response.data.tppuTingkatRisiko
      );
      setTppuTingkatRisiko(
        `${response.data.tppuTingkatRisiko} - ${tempTppuTingkatRisiko.nama}`
      );

      let tempTpptTingkatRisiko = pilihanTingkatRisikos.find(
        (tingkatRisiko) => tingkatRisiko.id == response.data.tpptTingkatRisiko
      );
      setTpptTingkatRisiko(
        `${response.data.tpptTingkatRisiko} - ${tempTpptTingkatRisiko.nama}`
      );

      let tempPpspmTingkatRisiko = pilihanTingkatRisikos.find(
        (tingkatRisiko) => tingkatRisiko.id == response.data.ppspmTingkatRisiko
      );
      setPpspmTingkatRisiko(
        `${response.data.ppspmTingkatRisiko} - ${tempPpspmTingkatRisiko.nama}`
      );
    }
  };

  const deleteTingkatRisiko = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteTingkatRisiko/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setSearchTerm("");
      setKodeTingkatRisiko("");
      setNamaTingkatRisiko("");
      setTppuTingkatRisiko("");
      setTpptTingkatRisiko("");
      setPpspmTingkatRisiko("");
      navigate("/tingkatRisiko");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${namaTingkatRisiko} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(
      `${setting.namaPerusahaan} - ${setting.kabupatenPerusahaan}`,
      15,
      10
    );
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar TingkatRisiko`, 90, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "TingkatRisiko",
    sheet: "DaftarTingkatRisiko",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container ref={ref}>
      <h3>Master</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Tingkat Risiko</h5>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getTingkatRisikos();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getTingkatRisikos();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>Kode</th>
                <th>Nama</th>
                <th>TPPU</th>
                <th>TPPT</th>
                <th>PPSPM</th>
              </tr>
            </thead>
            <tbody>
              {tingkatRisikos.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.kodeTingkatRisiko}</td>
                  <td>{user.namaTingkatRisiko}</td>
                  <td>{user.tppuTingkatRisiko}</td>
                  <td>{user.tpptTingkatRisiko}</td>
                  <td>{user.ppspmTingkatRisiko}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>Kode</th>
                <th>Nama</th>
                <th>TPPU</th>
                <th>TPPT</th>
                <th>PPSPM</th>
              </tr>
              {tingkatRisikos.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.kodeTingkatRisiko}</td>
                  <td>{user.namaTingkatRisiko}</td>
                  <td>{user.tppuTingkatRisiko}</td>
                  <td>{user.tpptTingkatRisiko}</td>
                  <td>{user.ppspmTingkatRisiko}</td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          addLink={`/tingkatRisiko/tambahTingkatRisiko`}
          editLink={`/tingkatRisiko/${id}/edit`}
          deleteUser={deleteTingkatRisiko}
          nameUser={kodeTingkatRisiko}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Kode :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={kodeTingkatRisiko} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Nama :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={namaTingkatRisiko} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    TPPU :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={tppuTingkatRisiko} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    TPPT :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={tpptTingkatRisiko} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    PPSPM :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={ppspmTingkatRisiko}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableTingkatRisiko currentPosts={tingkatRisikosPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilTingkatRisiko;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
